<template>
  <!-- debug purposes -->
  <div
    v-if="false"
    class="fixed top-32 right-6 bg-purple-200 p-3"
    style="z-index: 123123; max-height: 30vh; overflow-y: auto"
  >
    <!-- {{ currentCookiesState.value }}
    <hr />
    {{ currentCookiesState }} -->

    <!-- <pre>
        cookies
        {{ currentCookies }}
        <hr />
        state
        {{ currentCookiesState }}

      </pre> -->
  </div>

  <template v-if="renderable">
    <!-- 1) Welcome panel -->
    <div v-show="appCurrentState == 1" class="CookieManager CookieManager-Panel-1">
      <div class="Container py-6">
        <div class="Row">
          <div class="Col w-full space-y-6">
            <div v-html="getText('block1_text')"></div>
            <p class="flex flex-wrap items-center justify-center gap-5">
              <button
                @click="
                  save(
                    cookieTypes.map(c => c.identifier),
                    'ACCEPT_ALL',
                    4
                  )
                "
                class="CookieManager__Button"
              >
                {{ $t('Přijmout vše') }}
              </button>
              <button
                class="CookieManager__Button"
                @click="
                  $store.dispatch('tinyModal/open', {
                    id: 'CookieManager-Panel-3'
                  }),
                    setAppState(3)
                "
              >
                {{ $t('Nastavení') }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 2) State panel -->
    <div v-show="appCurrentState == 2" class="CookieManager CookieManager-Panel-2">
      <div class="Container py-4">
        <div class="Row">
          <div class="Col w-full">
            <div class="text-right">
              <button @click="setAppState(4)">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M16.066 8.995a.75.75 0 1 0-1.06-1.061L12 10.939L8.995 7.934a.75.75 0 1 0-1.06 1.06L10.938 12l-3.005 3.005a.75.75 0 0 0 1.06 1.06L12 13.06l3.005 3.006a.75.75 0 0 0 1.06-1.06L13.062 12l3.005-3.005Z"
                  />
                </svg>
              </button>
            </div>

            <div class="space-y-4">
              <h2>{{ $t('Nastavení cookies') }}</h2>
              <h3>{{ $t('Současný stav') }}</h3>
              <div>
                <div
                  v-for="c in cookieTypes"
                  :key="c.id"
                  class="flex items-center gap-x-1"
                  :class="{
                    'text-green-600': isCookieTypeAllowed(c),
                    'text-red-600': !isCookieTypeAllowed(c)
                  }"
                >
                  <!-- OK -->
                  <svg
                    v-if="isCookieTypeAllowed(c)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 15 15"
                  >
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="m11.39 5.312l-4.318 5.399L3.68 7.884l.64-.768l2.608 2.173l3.682-4.601l.78.624Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <!-- NOK -->
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M16.066 8.995a.75.75 0 1 0-1.06-1.061L12 10.939L8.995 7.934a.75.75 0 1 0-1.06 1.06L10.938 12l-3.005 3.005a.75.75 0 0 0 1.06 1.06L12 13.06l3.005 3.006a.75.75 0 0 0 1.06-1.06L13.062 12l3.005-3.005Z"
                    />
                  </svg>
                  {{ c.name }}
                </div>
              </div>
              <div class="flex justify-center">
                <button
                  class="CookieManager__Button"
                  @click="
                    $store.dispatch('tinyModal/open', {
                      id: 'CookieManager-Panel-3'
                    }),
                      setAppState(3)
                  "
                >
                  {{ $t('Změnit nastavení') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3) Settings panel -->
    <teleport v-if="appCurrentState === 3" to="#teleport">
      <transition name="fade" appear :css="true">
        <div class="ModalOverlay"></div>
      </transition>

      <div class="ModalOverlay2" :style="cssVars">
        <div @click="closeFromWrapper" class="ModalWrapper" ref="modalWrapper">
          <transition name="pop" appear :css="true">
            <div class="ModalContent">

              <div class="CookieManager CookieManager-Panel-3">
                <div class="p-5">
                  <div class="space-y-4">
                    <cookie-manager-settings :cookie-types="cookieTypes" />
                  </div>
                </div>
              </div>

            </div>
            <!-- </div> -->
          </transition>
        </div>
      </div>
    </teleport>





    <!-- 4) Levitujici blok ;) po vsech akcich -->
    <div
      v-show="appCurrentState == 4"
      @click="setAppState(2)"
      class="CookieManager CookieManager-Panel-4 cursor-pointer"
    >
      <div class="">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
            <path d="M21.8 14c-.927 4.564-4.962 8-9.8 8c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95" />
            <path
              d="M6.5 10a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1Zm14-6a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1ZM12 19a1 1 0 1 1 0-2a1 1 0 0 1 0 2Zm-5-3.99l.01-.011m9.99.011l.01-.011M11 12.01l.01-.011M21 9.01l.01-.011M17 6.01l.01-.011M11 2c-.5 1.5.5 3 2.085 3C11 8.5 13 12 18 11.5c0 2.5 2.5 3 3.7 2.514"
            />
          </g>
        </svg>
      </div>
    </div>

    <!-- For element which can be placed separately from this component, use Teleport in slot -->
    <slot name="link" v-bind="{ triggerCookiePopup: () => {
      setAppState(3)
    }, setAppState }"></slot>


  </template>
</template>

<script>
import { savedCallback, clearUnwantedCookies } from './CookieManagerActions.js'

import { useStorage } from '../../composables/Storage.js'
import { useStorageCookie } from '../../composables/StorageCookie.js'

// eslint-disable-next-line no-unused-vars
const [, fullListSave] = useStorage('cookieManager.fullList', [], 'local')
const [currentCookies, saveCookies] = useStorageCookie('cookieManager.selectedCookies', [])
const [currentCookiesState, saveCookiesState] = useStorageCookie('cookieManager.state', 'N/A')


export default {
  props: ['cookieTypes', 'fullList', 'texts'],
  data() {
    return {
      renderable: false,
      appState: null
    }
  },
  computed: {
    appCurrentState() {
      if (this.appState === null) {
        // prazdne pole, nic si nepovolil
        if (this.currentCookies.value.length === 0) {
          return 1
        }
        // jinak ma nejake cookies nebo ACCEPT_ALL nebo DENY_ALL
        return 4
      }

      return this.appState
    },
    currentCookies() {
      return currentCookies
    },
    currentCookiesState() {
      return currentCookiesState
    },
    savedCallback() {
      return savedCallback.value
    },
      cssVars() {
      return {
        '--modalMaxWidth': '1000px'
      }
    }
  },
  methods: {
    getText(place) {
      return this.texts[place] ?? '--UNDEFINED TEXT--'
    },
    setAppState(state) {
      this.appState = state
    },
    saveCookies(cookies) {
      saveCookies(cookies)
    },
    saveCookiesState(state) {
      saveCookiesState(state)
    },
    isCookieTypeAllowed(c) {
      return (
        c.checkable === 0 ||
        this.currentCookies.value.includes(c.identifier) ||
        this.currentCookies.value.includes('ACCEPT_ALL')
      )
    },
    save(cookies, cookiesState, appStep = null) {
      this.saveCookies(cookies)
      this.saveCookiesState(cookiesState)

      if (appStep) {
        this.setAppState(appStep)
      }
      fullListSave(this.fullList)
      this.savedCallback(this.currentCookies.value, this.currentCookiesState.value, clearUnwantedCookies)
    }
  },
  provide() {
    return {
      fullList: this.fullList,
      getText: this.getText,
      appCurrentState: this.appCurrentState,
      setAppState: this.setAppState,
      currentCookies: this.currentCookies,
      currentCookiesState: this.currentCookiesState,
      saveCookiesState: this.saveCookiesState,
      saveCookies: this.saveCookies,
      save: this.save
    }
  },

  watch: {
    appState: {
      handler(appState) {
        if (appState == 3) {
          document.documentElement.classList.add('TinyModalOpened')
        } else {
           document.documentElement.classList.remove('TinyModalOpened')
        }
      },
      immediate: true
    },
    savedCallback: {
      handler(callback) {
        if (callback) {
          this.renderable = true
          fullListSave(this.fullList)
          callback(this.currentCookies.value, this.currentCookiesState.value, clearUnwantedCookies)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/components/_cookie-manager.scss';
</style>

<style lang="scss">

html.TinyModalOpened {
  @apply overflow-hidden;

  @supports not (-webkit-touch-callout: none) {
    padding-right: 17px;
  }
}

</style>